import { MenuItem } from '@mui/material';
import { ReactNode } from 'react';

import { useModalMenuContext } from '../../hooks/useModalMenuContext';

type MenuElementProps = {
  children: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  variant?: 'danger';
  menuKey?: string;
  onClick?: () => void;
};

export const MenuElement = ({
  menuKey,
  onClick,
  selected,
  disabled,
  children,
  variant,
}: MenuElementProps) => {
  const { selectedMenuKey, setSelectedMenuKey } = useModalMenuContext();

  const isSelected = menuKey ? selectedMenuKey === menuKey : selected;

  const handleClick = () => {
    if (menuKey) {
      setSelectedMenuKey(menuKey);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <MenuItem
      onClick={handleClick}
      selected={isSelected}
      disabled={disabled}
      sx={{
        color:
          variant === 'danger'
            ? 'var(--error-error-color)'
            : 'var(--text-text-secondary-color)',
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        padding: '7px 16px',
        svg: {
          width: 16,
          height: 'auto',
          fill:
            variant === 'danger'
              ? 'var(--error-error-color)'
              : 'var(--text-text-secondary-color)',
        },
        '&:hover': {
          backgroundColor: 'var(--button-button-secondary-color)',
        },
        '&.Mui-selected': {
          color: 'var(--text-text-secondary-color)',
          backgroundColor: 'var(--button-button-secondary-color)',
          fontWeight: 700,
          svg: {
            fill:
              variant === 'danger'
                ? 'var(--error-error-color)'
                : 'var(--text-text-secondary-color)',
          },
          '&:hover': {
            backgroundColor: 'var(--button-button-secondary-color)',
          },
        },
      }}
    >
      {children}
    </MenuItem>
  );
};
